import React, { useRef, useEffect } from 'react';
import logo from '../img/logo.png';
import banner from '../img/vid/banner_video.mp4';
//gsap happens
import { TweenMax, gsap, Power3 } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

function Banner() {
  let bannerRef = useRef([]);

  useEffect(() => {
    TweenMax.staggerFrom(
      bannerRef.current,
      2,
      {
        y: 15,
        ease: Power3.easeOut,
        opacity: 0,
      },
      1
    );
  }, []);

  return (
    <>
      <section className='banner d-flex-col align-items-center justify-content-center gap-1 text-center'>
        <img
          ref={(element) => {
            bannerRef.current[1] = element;
          }}
          className='banner_slogan'
          src={logo}
          alt='SQREEM Technologies Logo'
        />
        <p
          ref={(element) => {
            bannerRef.current[2] = element;
          }}
        >
          {/* CREATING AI PLATFORMS THAT FOSTER CHANGE */}
          APPLIED AI PLATFORMS THAT ENHANCE CUSTOMER CONNECTION
        </p>
        <div className='gradient'></div>
        <div className='video d-flex align-items-center justify-content-center'>
          <video className='videoTag' autoPlay loop muted>
            <source src={banner} type='video/mp4' />
          </video>
        </div>
      </section>
    </>
  );
}

export default Banner;
